const site = {
  lang: 'en',
  displayTranslations: true,
  postsPerPage: 10
};

const supportedLanguages = {
  'en': 'English',
  'vi-VN': 'Tiếng Việt',
};

module.exports = {
  site,
  supportedLanguages
};
